<template>
  <div class="CartProducts">
    <div class="cart-products seccion-gris">
      <section id="servicios">
        <div id="etapas-compra">
          <div class="etapas-compra-hitos">
            <router-link :to="'/carrito'" class="hito-activo"
              >Carro de compras</router-link
            >
            <a class="hito-inactivo" disabled>Datos para la compra</a>
            <a class="hito-inactivo" disabled>Finalizar Compra</a>
          </div>
        </div>

        <div class="container cart-container">
          <div class="row">
            <div class="col-sm-12">
              <div class="card shadow-sm carrito">
                <div class="card-body">
                  <router-link
                    :to="'/productos'"
                    style="float: right;color: grey;text-decoration: none;"
                    >Seguir comprando</router-link
                  >
                  <h4 class="h4-carrito text-primary">Mi Carrito</h4>
                </div>
              </div>
            </div>
            <div class="col-lg-8 col-sm-12">
              <div class="row">
                <div class="col-sm-12">
                  <div class="row">
                    <template v-if="cartProducts.length > 0">
                      <div class="container">
                        <div class="card card-cart-products col-sm-12">
                          <ul class="list-group list-group-flush">
                            <li
                              class="list-group-item"
                              v-for="(item, index) in cartProducts"
                              :key="index"
                            >
                              <div class="row">
                                <div
                                  class="col-6 col-sm-2"
                                  @click="navigateProductDetail(item)"
                                >
                                  <img
                                    class="armaq-top mt-2"
                                    v-bind:src="
                                      imgPreUrl + item.photo_product + '.jpg'
                                    "
                                    style="width: 100px;"
                                    alt="Card image cap"
                                  />
                                </div>
                                <div class="col-6 col-sm-7 margen-automatico">
                                  <template v-if="item.subproduct.id_lote == 0">
                                    <p>
                                      <strong>{{ item.name_product_es }}</strong>
                                    </p>
                                  </template>
                                  <template v-else>
                                    <p>
                                      <strong>{{
                                        item.name_product_es +
                                          ' Lote: ' +
                                          item.subproduct.lote_sku
                                      }}</strong>
                                    </p>
                                  </template>

                                  <p>
                                    {{ item.price_product | currency }} X
                                    <span class="span-cantidad-calculator"
                                      ><strong>{{ item.qty }} </strong></span
                                    >
                                  </p>
                                  <p>
                                    <strong>{{
                                      (item.price_product * item.qty) | currency
                                    }}</strong>
                                  </p>
                                </div>
                                <div class="col-12 col-sm-3 margen-automatico">
                                  <div class="btn-group btn-ancho-total">
                                    <div class="row">
                                      <template
                                        v-if="item.subproduct.id_lote == 0"
                                      >
                                        <div class="col-12">
                                          <number-input
                                            v-model="item.qty"
                                            :min="1"
                                            :max="item.stock_product"
                                            center
                                            controls
                                            @change="modifyPriceinDisplay()"
                                          ></number-input>
                                        </div>
                                        <div class="col-12">
                                          <br /><button
                                            type="button"
                                            class="btn btn-al-celeste-solid btn-sm ancho-total"
                                            v-on:click="removeProductCart(item)"
                                          >
                                            Eliminar <i class="fa fa-trash"></i>
                                          </button>
                                        </div>
                                      </template>
                                      <template v-else>
                                        <div class="col-12">
                                          <number-input
                                            v-model="item.qty"
                                            :min="1"
                                            :max="item.subproduct.lote_stock"
                                            center
                                            controls
                                            @change="modifyPriceinDisplay()"
                                          ></number-input>
                                        </div>
                                        <div class="col-12">
                                          <br /><button
                                            type="button"
                                            class="btn btn-al-celeste-solid btn-sm ancho-total"
                                            v-on:click="removeProductCart(item)"
                                          >
                                            Eliminar <i class="fa fa-trash"></i>
                                          </button>
                                        </div>
                                      </template>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="error-template container">
                        <h2>Su carrito está vacío</h2>
                        <div class="error-details">Agrega productos ahora >></div>
                        <div class="error-actions">
                          <router-link to="/productos"
                            >Seguir comprando</router-link
                          >
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="container">
                    <br />
                    <p>
                      <strong>NOTA:</strong> Este es un producto de alta demanda,
                      por esta razón le sugerimos realizar su compra lo antes
                      posible. Recuerde que el añadir el producto al carrito no
                      reserva el producto.
                    </p>
                  </div>

                  <br />
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-sm-12">
              <cart-calculator ref="cartCalculator"></cart-calculator>
            </div>
          </div>
        </div>
      </section>
      <TwoModules></TwoModules>
      <News></News>
    </div>
  </div>
</template>

<script>
import TwoModules from '@/components/products/TwoModules.vue';
import News from '@/components/products/Guia.vue';
import { config_settings } from '../../../../config.js';
import { mapState, mapActions, mapMutations } from 'vuex';
import CartCalculator from '../CartCalculator/CartCalculator';

//HTTP ERROR STATUS
const NOT_FOUND = 404;
const BAD_REQUEST = 400;
const UNAUTHORIZED = 401;
const INTERNAL_SERVER_ERROR = 500;

export default {
  name: 'CartProducts',
  components: { CartCalculator, TwoModules, News },
  data() {
    return {
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
    };
  },
  computed: mapState(['cartProducts']),
  methods: {
    /* Resetting the store and localstorage after removing product from cart */
    ...mapMutations(['SET_CART_PRODUCTS']),

    removeProductCart(product) {
      var products = JSON.parse(localStorage.getItem('iki-cart'));
      for (let i = 0; i < products.length; i++) {
        if (products[i].code_product === product.code_product) {
          products.splice(i, 1);
        }
      }
      this.SET_CART_PRODUCTS(products);
      localStorage.setItem('iki-cart', JSON.stringify(products));
      this.$refs.cartCalculator.analizeCart();
    },
    modifyPriceinDisplay() {
      var products = this.cartProducts;
      this.SET_CART_PRODUCTS(products);
      localStorage.setItem('iki-cart', JSON.stringify(products));
      this.$refs.cartCalculator.analizeCart();
    },
    navigateProductDetail(product) {
      this.$router.push({
        name: 'detalle-productos',
        params: { id: product.code_product },
      });
    },
    scroll_inicio() {
      window.scrollTo(0, 0);
    },
  },

  created() {
    this.scroll_inicio();
  },
};
</script>

<style lang="scss" src="./CartProducts.scss"></style>
